import React, { Component } from "react";
import { connect } from "react-redux";
import { Collapse } from "reactstrap";
import { Route, Switch, Redirect } from "react-router-dom";

import Setting from "../components/setting";
import SidebarNav from "../components/sidebarNav";
import ChangePassword from "../components/changePassword";
import routes from "../routes/routes";

import "react-toastify/dist/ReactToastify.min.css";

class Dashboard extends Component {
  state = {
    isOpen: false,
    isOpenSidebar: false,
    isOpenChangePassword: false
  };

  componentDidMount() {}

  // toggle Collapse
  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  // toggle Sidebar
  toggleSidebar = () => {
    this.setState({ isOpenSidebar: !this.state.isOpenSidebar });
  };

  // toggle change password modal
  toggleChangePassword = () => {
    this.setState({ isOpenChangePassword: !this.state.isOpenChangePassword });
  };

  render() {
    let { token, history } = this.props;
    // check token if empty move to home page;
    if (token === "") {
      //  return to home page
      return <Redirect to="/" />;
    }

    return (
      <div
        className={this.state.isOpenSidebar ? "d-flex toggled" : "d-flex"}
        id="wrapper"
      >
        <div className="bg-primary-theme border-right" id="sidebar-wrapper">
          <div className="sidebar-heading">
            <h3 className="text-white text-center">Gmandi Admin</h3>
          </div>
          <div />

          {/* sidebarNave */}
          <SidebarNav />
        </div>

        <div id="page-content-wrapper">
          <nav className="navbar navbar-expand-lg navbar-primary-theme bg-primary-theme border-bottom">
            {/* <NavbarToggler onClick={this.toggle} /> */}

            <i
              className="fas fa-bars fa-2x mr-2"
              id="hamburgerIcon"
              style={{ cursor: "pointer", color: "white" }}
              onClick={this.toggleSidebar}
            />

            <Collapse isOpen={this.state.isOpen} navbar>
              <div className="topbar-divider d-none d-sm-block" />
            </Collapse>

            {/* Setting component */}
            <Setting
              data={this.props}
              toggleChangePassword={this.toggleChangePassword}
            />
            <ChangePassword
              modal={this.state.isOpenChangePassword}
              toggle={this.toggleChangePassword}
            />
          </nav>

          <div className="container-fluid">
            <Switch>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  exact={route["exact"]}
                  path={route["path"]}
                  component={route["component"]}
                />
              ))}
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: state.auth.token
});

export default connect(mapStateToProps)(Dashboard);
